import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { MessageElements } from '../../../../components';
import './style.sass';

const DescriptionChannel = ({
  createdAt,
  description,
  createdBy,
  t,
}) => (
  <div className="description-channel">
    <p className="description-channel__text selectable-text">
      <MessageElements
        options={{ parseToPlainText: true }}
      >
        {description}
      </MessageElements>
    </p>
    <span className="description-channel__created">
      <span className="description-channel__created-helper">{t('Created')}</span>
      { createdBy && `${t('by')} ${createdBy} ` }
      {`${t('on')} ${moment(new Date(createdAt.replace(' ', 'T'))).format('MMMM D, YYYY')}`}
    </span>
  </div>
);

DescriptionChannel.propTypes = {
  createdAt: PropTypes.string.isRequired,
  createdBy: PropTypes.string.isRequired,
  description: PropTypes.string,
  t: PropTypes.func.isRequired,
};

DescriptionChannel.defaultProps = {
  description: '',
};

export default React.memo(DescriptionChannel);
